import { NgClass } from '@angular/common';
import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTooltip } from '@angular/material/tooltip';

export interface ISearchScopeFolder {
  icon: string;
  outlinedIcon?: boolean;
  name: string;
}

@Component({
  selector: 'app-data-rules-search',
  templateUrl: './data-rules-search.component.html',
  styleUrls: ['./data-rules-search.component.scss'],
  imports: [NgClass, MatTooltip]
})
export class DataRulesSearchComponent implements OnChanges {
  @Input() value = '';
  @Input() placeholder = 'Search (Ctrl+Shift+F)...';
  @Input() scopeFolder: ISearchScopeFolder | null = null;
  @Output() searchChange = new EventEmitter<string>();

  @ViewChild('searchInput') searchInput: ElementRef<HTMLInputElement>;

  activePlaceholder = 'Search (Ctrl+Shift+F)...';
  scopeTooltip = '';

  constructor(private dialog: MatDialog) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['scopeFolder'] || changes['placeholder']) {
      this.activePlaceholder = this.scopeFolder ? `Search ${this.scopeFolder.name}...` : this.placeholder;
      this.scopeTooltip = this.scopeFolder ? `Searching within ${this.scopeFolder.name}` : '';
    }
  }

  // Keyboard Shortcuts
  // - Use Ctrl + Shift + F to focus the search input
  @HostListener('document:keydown', ['$event'])
  protected handleKeydownEvent(event: KeyboardEvent): void {
    if (this.dialog.openDialogs.length === 0 && event.ctrlKey && event.shiftKey && event.code === 'KeyF') {
      event.preventDefault();
      this.searchInput?.nativeElement.focus();
    }
  }

  onKeyup(event: Event): void {
    this.searchChange.emit((event.target as HTMLInputElement).value);
  }

  clearInput(input: HTMLInputElement): void {
    input.value = '';
    this.searchChange.emit('');
    this.searchInput?.nativeElement.focus();
  }
}
